const { width, height } = window.screen

export const vhp = (fontSize) => fontSize * (height / 100)
export const vwp = (fontSize) => fontSize * (width / 100)
export const vhwp = (fontSize) => fontSize * ((height / width))
